const EDUHOT_FUNNEL = 788_695
const ESTETUS_FUNNEL = 744_036
const SOEDUCADOR_GRADUATE_FUNNEL = 773_574

export interface AgendorFunnelConfig {
  graduate?: string | number | null
  technical?: string | number | null
}

/** Allowed values for Agendor custom field `origem_contato` (must match CRM options exactly). */
export const AGENDOR_CONTACT_ORIGIN = {
  VER_PROGRAMA_COMPLETO: 'Ver programa completo',
  QUERO_ME_INSCREVER: 'Quero me inscrever',
  FALAR_COM_CONSULTOR: 'Falar com um consultor',
  TENHO_INTERESSE: 'Tenho interesse',
  TENHO_DUVIDA: 'Tenho dúvida',
} as const

export type AgendorContactOrigin =
  (typeof AGENDOR_CONTACT_ORIGIN)[keyof typeof AGENDOR_CONTACT_ORIGIN]

/** Single source of truth for the "Você já é graduado?" answer values, shared across all templates. */
export const GRADUATE_ANSWER_VALUES = ['sim', 'nao', 'finalizando'] as const

export type GraduateAnswer = (typeof GRADUATE_ANSWER_VALUES)[number]

export const GRADUATE_ANSWER_OPTIONS: ReadonlyArray<{
  value: GraduateAnswer
  label: string
}> = [
  { value: 'sim', label: 'Sim' },
  { value: 'nao', label: 'Não' },
  { value: 'finalizando', label: 'Estou finalizando' },
]

const GRADUATE_ANSWER_LABELS: Record<GraduateAnswer, string> = {
  sim: 'Sim',
  nao: 'Não',
  finalizando: 'Estou finalizando',
}

/** Label sent to Agendor custom field `voce_ja_e_graduado?` and deal description. */
export function getGraduateAnswerLabel(answer: GraduateAnswer): string {
  return GRADUATE_ANSWER_LABELS[answer]
}

/** Only "sim" counts as already graduated for funnel-routing purposes. */
export function isGraduateAnswerGraduated(answer: GraduateAnswer): boolean {
  return answer === 'sim'
}

interface ResolvePostgraduateAgendorFunnelParams {
  brandName?: string | null
  /** @deprecated Ignored — postgraduate deals always use the graduate funnel. */
  isGraduate?: boolean
  agendorFunnel?: AgendorFunnelConfig | null
}

/** Always resolves the graduate funnel. Never routes to technical. */
export function resolvePostgraduateAgendorFunnel({
  brandName,
  agendorFunnel,
}: ResolvePostgraduateAgendorFunnelParams): number {
  const brand = (brandName ?? '').toLowerCase()

  if (brand.includes('eduhot')) {
    return EDUHOT_FUNNEL
  }

  if (brand.includes('estetus')) {
    return ESTETUS_FUNNEL
  }

  const configured = agendorFunnel?.graduate

  if (configured != null && configured !== '') {
    return Number(configured)
  }

  return SOEDUCADOR_GRADUATE_FUNNEL
}

export function formatGraduateDealDescription(
  courseName: string | undefined | null,
  graduateAnswer: GraduateAnswer
): string {
  const graduateLabel = GRADUATE_ANSWER_LABELS[graduateAnswer]
  const courseLabel = courseName?.trim() ?? ''

  if (!courseLabel) {
    return `Você já é graduado?: ${graduateLabel}`
  }

  return `${courseLabel}\nVocê já é graduado?: ${graduateLabel}`
}
